import React, { useState } from "react";
import "./index.css";
import ImageTag from "../ImageTag/Index";
import Title from "../Title/Index";
import Fill from '../Button/Outline/Index';

const Featureslider = ({ Data }) => {
  const [listItems, setListItems] = useState(false); 
  const showAll = () => setListItems(true);

  return (
    <section className="w-full swiperbtn p-100 bg-[#dae5de] flex flex-wrap justify-end" data-aos="fade-right" data-aos-offset="200" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">
      <div className="container md:m-0">
      <div className='w-full lg:w-[900px] m-auto px-2 sm:px-0'>
        <Title firstHeading={Data.heading} secondHeading={Data.title} subTitle={Data.descp} _secondHeading={'heading2 headingFont2 primary'} _class={'text-start'} />
      </div>
      <div className="w-full flex flex-wrap lg:w-[82%] justify-content-between float-end flex-center flex-direction-mobile">
        <div className="w-full lg:w-1/4">
          <ul className='listItems desktop-show'>
            {Data.features.slice(0, listItems ? Data.features.length : 10).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <ul className='listItems mobile-show'>
            {Data.features.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          {Data.features.length > 10 && !listItems && (
            <div className="w-full desktop-show">
              <Fill buttonText={'Read More'} showAll={showAll} _class={'mt-5'}/>
            </div>
          )}
        </div>
        <div className="w-full lg:w-2/3 pl-sm-5">
          <div className="featureSlider bottomPosition w-full" data-aos="fade-in" data-aos-offset="200" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">       
              <ImageTag  ImagePath={'http://triverseadvertising.com/ss-group/ss-camasa/clubBanner.webp'} ImageClass='w-full'/>
            {/* <Swiperslider slidesPerView={1.9} spaceBetween={50} navigation={true} timeDelay={'800000'} tabspaceBetween={15}>
              {Data.clubData.map((items, index) => (           
                <div className="w-full position-relative featureSlide" key={index}>
                  <ImageTag ImagePath={items.imagePath} ImageAlt={items.heading} />
                </div>
              ))}
            </Swiperslider> */}
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default Featureslider;
